import { isSuccessStatusCode } from 'owa-http-status-codes';
import { getAccessTokenforResource } from 'owa-tokenprovider';

const TEAMS_CHANNELS_RESOURCE = 'https://chatsvcagg.teams.microsoft.com';
const TEAMS_CHANNELS_URL = TEAMS_CHANNELS_RESOURCE + '/api/v1/teams/users/me/teams';

/**
 * Fetch all the teams and channels from the Teams API
 */
export default async function fetchTeamsAndChannels() {
    const token = await getAccessTokenforResource(TEAMS_CHANNELS_RESOURCE, 'OwaCalendarTeams');

    if (!token) {
        throw Error('No access token for resource');
    }

    const response = await fetch(TEAMS_CHANNELS_URL, {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
    });

    if (isSuccessStatusCode(response.status)) {
        return response.json();
    } else {
        throw Error('HTTP status ' + response.status);
    }
}
